import React from 'react';
import { connect } from 'react-redux';

import * as UserAction from '../../../actions/User.actions';
import awardIcon from '../../../assets/award-large.png';
import { ACHIEVEMENTS_FORM } from '../../../constants/FormNames';
import { ValidationTypes } from '../../../enums/ValidationTypes';
import '../../../styles/components/options/popups/edit_popup_content.scss';
import Button from '../../Button';
import TextInput from '../../TextInput';

const AddAchevements = ({
	formData,
	type = 'text',
	addAchievements,
	onHanleSuccess,
}) => {
	const handleSave = () => {
		addAchievements(
			{
				title: formData?.title,
				subTitle: formData?.sub_title,
				summary: formData?.summary,
			},
			sus => {
				console.log(sus);
				onHanleSuccess(sus);
			},

			err => {
				console.log(err);
			}
		);
	};

	return (
		<div className='edit_name_container'>
			<div className='input-wrapper'>
				<div className='input-container'>
					{/* <span className='input-title'>{title}</span> */}
					<div className='top-inputs'>
						<div className='inputs'>
							<TextInput
								type={type}
								id={'title'}
								placeholder={'Title'}
								form={ACHIEVEMENTS_FORM}
								value={formData?.title}
								name={'title'}
								validations={[ValidationTypes.required]}
								hidden={false}
								rightSideIcon={null}
								mainIcon={null}
							/>
							<TextInput
								type={type}
								id={'sub_title'}
								placeholder={'Subtitle'}
								form={ACHIEVEMENTS_FORM}
								value={formData?.sub_title}
								name={'sub_title'}
								validations={[ValidationTypes.required]}
								hidden={false}
								rightSideIcon={null}
								mainIcon={null}
							/>
						</div>
						<div className='icon'>
							<img src={awardIcon} alt='' />
						</div>
					</div>
					<TextInput
						type={type}
						id={'summary'}
						placeholder={'Summery'}
						form={ACHIEVEMENTS_FORM}
						value={formData?.summary}
						name={'summary'}
						validations={[ValidationTypes.required]}
						hidden={false}
						rightSideIcon={null}
						mainIcon={null}
					/>
				</div>
			</div>
			<div className='button-wrapper'>
				<Button
					active
					className='save-button'
					labal='Save'
					onClickEvent={() => handleSave()}
				></Button>
			</div>
		</div>
	);
};

const mapStateToProps = ({ forms, user }) => ({
	formData: forms?.[ACHIEVEMENTS_FORM]?.values || {},
	user,
});

const mapDispatchToProps = {
	addAchievements: UserAction.addAchievements,
};

export default connect(mapStateToProps, mapDispatchToProps)(AddAchevements);
